define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/html",
	"csi/xml"
], function(declare, Controller, html, xml) {

	return declare(Controller, {
		/**
		 * @override
		 * Ensure that all results are loaded on page
		 */
		onPreActionDeferreds(dfds) {
			dfds.push(this.widget.queryMoreToTarget(true));
		},

		/**
		 * @override
		 * Classify errors so you can filter
		 */
		toWriter() {
			const view = this.widget;
			const w = this.m_writer;
			const errorSpec = view.attributeSpecs.find({name: "Errors"});
			const nl = html.queryDom([html.getDataAttributeSelector(html.DATA_HEADING, errorSpec.key.untypedString)], view.bodyNode);

			nl.forEach((td) => {
				const url = view.getRefNodeUrl(td.parentNode);
				const s = td.innerText.trim();
				let n;

				if (s) {
					if (s.startsWith(view.ERROR_MISSING)) {
						n = 1;
					} else if (s.startsWith(view.ERROR_PREFS)) {
						n = 2;
					} else if (s.startsWith(view.ERROR_KEY)) {
						n = 3;
					} else if (s.startsWith(view.ERROR_ORPHAN)) {
						n = 4;
					} else if (s.startsWith(view.ERROR_TARGET)) {
						n = 6;
					} else {
						// Keys are inconsistent with model/view
						n = 5;
					}
				} else {
					n = 0;
				}

				w.changeNode(url).changeAttribute("Migrate", xml.ATTR_INTEGER, n);
			});
		},

		/**
		 * @override
		 * refresh Migrate column
		 */
		postProcessSuccess() {
			const h = this.widget.defView.findHeading("Migrate");
			if (h) {
				this.widget.refreshHeading(h);
			}
		}
	});
});